"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SenderSubjectFull_1 = require("./components/SenderSubjectFull");
var discardSenderSubjectOption_1 = require("./actions/discardSenderSubjectOption");
var saveSenderSubjectOption_1 = require("./actions/saveSenderSubjectOption");
var isSenderSubjectOptionDirty_1 = require("./utils/isSenderSubjectOptionDirty");
var SenderSubjectOption = {
    key: 'senderSubject',
    titleStringKey: 'optionTitle_senderSubjectOrder',
    searchTermsStringKey: 'optionTitle_senderSubjectOrder',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SenderSubjectFull_1.default, null); },
        isDirty: isSenderSubjectOptionDirty_1.default,
        onSave: saveSenderSubjectOption_1.default,
        onDiscard: discardSenderSubjectOption_1.default,
    },
};
exports.default = SenderSubjectOption;
//# sourceMappingURL=SenderSubjectOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-subject-option/lib/SenderSubjectOption.js
// module id = 5124
// module chunks = 2